import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconMap"><Path d="M3.53849 5.44652L8 3.95935L8 18.5405L4.96151 19.5533C3.50457 20.039 2 18.9545 2 17.4188V7.58105C2 6.61258 2.61972 5.75277 3.53849 5.44652Z" fill="currentColor"/><Path d="M14.5 20.0538L9.5 18.5154L9.5 3.94598L14.5 5.48445L14.5 20.0538Z" fill="currentColor"/><Path d="M16 20.0405L20.4615 18.5533C21.3803 18.2471 22 17.3872 22 16.4188V6.58105C22 5.0453 20.4954 3.96087 19.0385 4.44652L16 5.45935L16 20.0405Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMap;
